import React from 'react'
import { useTranslation } from 'react-i18next'
import { CommentLocationType } from '../../generated/graphql'
import { CommentsButton } from '../comments/CommentsButton'
import { EerSidebarContent } from '../eer/EerSidebarContent'
import { ProjectSubLayoutProps } from './ProjectSubDataLayout'
import { ProjectSubLayoutBase } from './ProjectSubLayoutBase'

export function EerLayout({
  children,
}: ProjectSubLayoutProps): React.ReactElement {
  const { t } = useTranslation()

  return (
    <ProjectSubLayoutBase
      title={t('eer.title')}
      sidebarContent={<EerSidebarContent />}
      menu={<CommentsButton locationType={CommentLocationType.FinnishEer} />}
    >
      {children}
    </ProjectSubLayoutBase>
  )
}
